import { DocumentationPage } from './_article.jsx';
export default function AccountAndSecurityPage({
  article,
  articles
}) {
  return <DocumentationPage article={article} articles={articles} />;
}